import queryString from 'query-string';
import { useCallback } from 'react';
import { useLocation } from 'react-router';

const useCrossDomainCopyPage = () => {
  const location = useLocation();
  const query = queryString.parse(location.search);

  const { from, fromDomain } = query;

  const clearFlowElements = useCallback(
    (campaign, nodeTypes) => {
      if (!fromDomain || !campaign.flow?.nodes) {
        return campaign;
      }

      campaign.flow.nodes = campaign.flow.nodes.map((node) => {
        if (!node.data?.custom?.values?.id) {
          return node;
        }

        const nodeType = node.data.custom.key;
        // Clear IDs for elements that don't exist in target domain
        if (nodeTypes.includes(nodeType) && node.data.custom.values.id) {
          delete node.data.custom.values.id;
        }

        return node;
      });

      return campaign;
    },
    [fromDomain]
  );

  return {
    from,
    fromDomain,
    clearFlowElements,
  };
};

export default useCrossDomainCopyPage;
